import { z } from 'zod'
import { baseUrl, postJson } from '@/api/http'

const responseSchema = z.object({ status: z.string() })

/**
 * Subscribe an email to the newsletter via our backend proxy, which holds the
 * Ecomail API key server-side. Returns on success; throws (HttpError) on
 * validation or upstream failure so the form can show a real error state.
 */
export async function subscribeToNewsletter(email: string): Promise<void> {
  await postJson(`${baseUrl}/newsletter/subscribe`, { email }, responseSchema)
}
